import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class FulfillmentPlanResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.fulfillmentPlan).get(options);
  }

  get(id) {
    return this.$resource(apis.fulfillmentPlan + id).get();
  }

  search(name = "", params) {
    return this.$resource(apis.fulfillmentPlan).get(assign(params, { name }));
  }

  post(item) {
    return this.$resource(apis.fulfillmentPlan).save(item);
  }

  update(id, item) {
    return this.$resource(apis.fulfillmentPlan + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default FulfillmentPlanResource;



// WEBPACK FOOTER //
// ./src/resources/fulfillmentPlan/fulfillmentPlan.resource.js